import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';
import { UsageProvider } from './contexts/UsageContext';
import { ChatProvider } from './contexts/ChatContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { ContextEngineProvider } from './contexts/ContextEngineContext';
import { captureUtmParams } from './utils/utmTracking';
import AppLayout from './components/AppLayout';
import Home from './components/Home';
import Chat from './pages/Chat';
import ChatHistory from './pages/ChatHistory';
import SignIn from './components/auth/SignIn';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import ChangePassword from './components/auth/ChangePassword';
import Dashboard from './components/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import ProjectManager from './components/projects/ProjectManager';
import ProjectDetail from './components/projects/ProjectDetail';
import DesignSystem from './pages/DesignSystem';
import Terms from './pages/Terms';
import LandingPage from './pages/LandingPage';
import Pricing from './pages/Pricing';
import Help from './pages/Help';
import ComingSoon from './pages/ComingSoon';
import SelectPlan from './pages/SelectPlan';
import PlanConfirmation from './pages/PlanConfirmation';
import CancelAccount from './pages/CancelAccount';
import AboutUs from './pages/AboutUs';
import Features from './pages/Features';
import WhoIsThisFor from './pages/WhoIsThisFor';
import Onboarding from './pages/Onboarding';

function App() {
  captureUtmParams();

  return (
    <DarkModeProvider>
      <AuthProvider>
        <UsageProvider>
          <ProjectProvider>
            <ContextEngineProvider>
            <ChatProvider>
              <SidebarProvider>
                <Router>
              <AppLayout>
              <Routes>
                <Route
                  path="/"
                  element={
                    <PublicRoute>
                      <LandingPage />
                    </PublicRoute>
                  }
                />

                <Route
                  path="/onboarding"
                  element={
                    <PrivateRoute>
                      <Onboarding />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <PrivateRoute>
                      <Home />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/chat-history"
                  element={
                    <PrivateRoute>
                      <ChatHistory />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/chat/:conversationId"
                  element={
                    <PrivateRoute>
                      <Chat />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <PrivateRoute>
                      <Dashboard />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/cancel-account"
                  element={
                    <PrivateRoute>
                      <CancelAccount />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/change-password"
                  element={
                    <PrivateRoute>
                      <ChangePassword />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/projects"
                  element={
                    <PrivateRoute>
                      <ProjectManager />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/projects/:projectId"
                  element={
                    <PrivateRoute>
                      <ProjectDetail />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/help"
                  element={
                    <PrivateRoute>
                      <Help />
                    </PrivateRoute>
                  }
                />

              <Route
                path="/signin"
                element={
                  <PublicRoute>
                    <SignIn />
                  </PublicRoute>
                }
              />
              <Route
                path="/register"
                element={
                  <PublicRoute>
                    <Register />
                  </PublicRoute>
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <PublicRoute>
                    <ForgotPassword />
                  </PublicRoute>
                }
              />
              <Route
                path="/reset-password"
                element={<ResetPassword />}
              />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />

              <Route path="/design-system" element={<DesignSystem />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/features" element={<Features />} />
              <Route path="/who-is-this-for" element={<WhoIsThisFor />} />
              <Route path="/select-plan" element={<SelectPlan />} />
              <Route
                path="/plan-confirmation"
                element={
                  <PrivateRoute>
                    <PlanConfirmation />
                  </PrivateRoute>
                }
              />
              <Route path="/coming-soon" element={<ComingSoon />} />

              <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </AppLayout>
              </Router>
            </SidebarProvider>
          </ChatProvider>
          </ContextEngineProvider>
        </ProjectProvider>
      </UsageProvider>
      </AuthProvider>
    </DarkModeProvider>
  );
}

export default App;
